export default __webpack_public_path__ + "static/realWorldImage1-2059848cb4988bc3575249f0e92c16ed.webp";